import React, {PropTypes} from "react";
import {connect} from "react-redux";
import HrAdminNavigation from "../../components/common/HrAdminNavigation";
import LinearProgress from "material-ui/LinearProgress";
import Banner from "../../components/common/Banner";
import * as actions from "../../redux/actions/Employee/employeeDetailActions";
import Footer from "../../components/common/utils/Footer";


class AdminHome extends React.Component {

  constructor(props) {
    super();
    this.state = {options: props.options, employees: [], loading: 0, banner: "HR admin", roles:props.empRoles};
    this.refresh = this.refresh.bind(this);
    this.remove = this.remove.bind(this);
    this.changeBanner = this.changeBanner.bind(this);
  }

  remove(empId) {

    this.props.refresh();

    let index = -1;
    this.state.employees.map((node, id)=> {
      if (node.employeeCode == empId)
        index = id;
    });
    let employees = this.state.employees;

    if (index != -1)
      employees.splice(index, 1);
    debugger;
    this.setState({employees: employees});


  }

  changeBanner(name) {
    this.setState({banner: name})
  }

  refresh(empId) {
    this.props.dispatch(actions.refreshEmployee(empId))
  }

  componentDidMount() {
    this.props.dispatch(actions.getEmployeeDetails());
  }

  render() {
    return (
      <div>
        <Banner name={this.state.banner}/>
        <div className="container" style={{marginLeft: '10', marginRight: '10', width: '100%'}}>
          <div className="wrapper-1">
            <div className="row clearfix">
              <div className="col-xs-12">
                <div id="tab_content" style = {{width: '105%'}}>
                  <HrAdminNavigation options={this.state.options} roles = {this.state.roles}/>
                  <div className="tab-content responsive" style={{padding: 0}}>
                    <div role="tabpanel" className="tab-panel">
                      <div className="row clearfix">
                        {this.props.state.length == 0 ?
                          <LinearProgress mode="indeterminate" style={{padding: '2px', width: '100%'}}/> :
                          <label></label> }
                        <div className="inner-col-wrap inner-table-wrap ">
                          {React.cloneElement(this.props.children, {
                            changeBanner: this.changeBanner,
                            employees: this.props.state,
                            constants: this.props.constants,
                            refresh: this.refresh,
                            remove: this.remove
                          })}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer/>
      </div>
    );
  }

}


AdminHome.defaultProps = {
  options: [
    {
      text: "People Search",
      active: true,
      url: "#/1/admin/peopleSearch",
      url2: '#/1/admin',
      role: "peopleSearch"

    },
    {
      text: "Exits",
      active: false,
      url: "#/1/admin/exit",
      role:"exits"
    },
    {
      text: "Exits F&F",
      active: false,
      url: "#/1/admin/exitFnF",
      role:"exitsFnF"
    }, {
      text: "OnBoarding",
      active: false,
      url: '#/1/admin/onBoarding',
      role:"onBoarding"
    }, {
      text: "OnBoarding - Expected",
      active: false,
      url: '#/1/admin/onBoardingExpected',
      role:"onBoardingExpected"
    },
    {
      text: "Leave",
      active: false,
      url: '#/1/admin/leave',
      role:"leave"
    },
    {
      text: "Upload",
      active: false,
      url: '#/1/admin/upload',
      role:"upload"
    },
    {
      text: "Download",
      active: false,
      url: '#/1/admin/download',
      role:"download"
    },
    {
          text: "CTC Split",
          active: false,
          url: '#/1/admin/ctcSplit',
          role:"ctcSplit"
    },
    {
      text: "Abandonment",
      active: false,
      url: '#/1/admin/abscond',
      role:"abscond"
    }

  ]
};
AdminHome.propTypes = {
  options: React.PropTypes.array
};

function mapStateToProps(state, ownState) {
  return {
    state: state.employeeDetails,
    constants: state.constants
  };
}


export default connect(mapStateToProps)(AdminHome);




/** WEBPACK FOOTER **
 ** ./src/feature/hradmin/AdminHome.js
 **/